import { Encrypt } from "../../utils";
import client from "./client";

/**
 *
 * @param { data : Object<{ email: string }>,
 *  headers: Object<{ x-did-token : string }> } data
 * @returns
 */
export const signUp = (data) => {
  return client.post("/auth/login", data.data, {
    headers: data.headers,
  });
};

export const refreshTokens = () => {
  return client.post("/auth/refresh-token");
};

export const getPayee = () => {
  return client.get("/me");
};

/**
 *
 * @param {Object} payload
 * {
 *    email: string,
 *     type: string, // google, apple
 *    token: string,
 *    logo: string,
 *    responseObject: object
 * }
 */
export const thirdPartyLogin = (payload) => {
  const enc = Encrypt(JSON.stringify(payload));
  return client.post("/auth/third-party", { encryptedReq: enc });
};

export const updateMfaStatus = (data) => {
  return client.post("/mfaStatus", data)
};
export const getFeedbackFormStatus = () => {
  return client.get("/feedback/survey");
};